import React from "react";

const NonBillable = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
          <path className="u_fill"
              d="M17.722 27.355c0-3.988 3.067-7.361 6.952-7.873v-9.405L16.495 2H5.658C4.227 2 3 3.227 3 4.658v21.674c0 1.534 1.227 2.658 2.658 2.658h12.269c-.103-.51-.205-1.022-.205-1.635zm-2.556-23.31l6.134 6.134h-6.134V4.045zm1.33 19.63h-1.33v1.328h-2.658v-1.329h-2.76v-2.658h5.418v-1.33h-4.09c-.715 0-1.328-.613-1.328-1.328v-4.09c0-.715.613-1.329 1.329-1.329h1.329V11.61h2.658v1.33h2.658v2.658h-5.419v1.329h4.09c.716 0 1.33.613 1.33 1.329v4.09c.204.715-.41 1.328-1.228 1.328z"
              fill={fill}
          />
          <path className="u_fill"
              d="M25.594 20.505c-3.783 0-6.747 3.067-6.747 6.747 0 3.783 3.067 6.748 6.747 6.748 3.783 0 6.748-3.067 6.748-6.748.102-3.68-2.965-6.747-6.748-6.747zm2.76 8.588a.494.494 0 010 .715l-.204.205a.494.494 0 01-.715 0l-1.636-1.738-1.636 1.738a.494.494 0 01-.716 0l-.204-.205a.494.494 0 010-.715l1.636-1.636-1.738-1.738a.494.494 0 010-.716l.204-.204a.494.494 0 01.716 0l1.636 1.738 1.635-1.636a.494.494 0 01.716 0l.204.204a.494.494 0 010 .716l-1.738 1.636 1.84 1.636z"
              fill={fill}
          />
    </svg>
);

export default NonBillable;